import React, {
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import * as ss from 'styled-system';
import { HeightProps, PositionProps, WidthProps } from 'styled-system';

import Box from 'components/Box';
import ScrollContext from 'containers/ScrollContext';
import ViewportContext from 'containers/ViewportContext';

export const PARALLAX_DEFAULT_SPEED = 300;
const Container = styled(
  React.forwardRef(
    (
      {
        className,
        children,
      }: {
        className?: string;
        children: ReactNode;
      },
      ref
    ) => (
      // @ts-expect-error ts-migrate(2322) FIXME: Type '((instance: unknown) => void) | MutableRefOb... Remove this comment to see the full error message
      <div className={className} ref={ref}>
        {children}
      </div>
    )
  )
)`
  ${ss.position}
  ${ss.top} 
  ${ss.right} 
  ${ss.bottom} 
  ${ss.left}
  ${ss.zIndex}
  ${ss.space} 
  ${ss.display}
  ${ss.width} 
  ${ss.height} 
  ${ss.maxWidth} 
  ${ss.maxHeight} 
  ${ss.minWidth} 
  ${ss.minHeight}
`;
const TransformContainer = styled.div.attrs(
  ({ translateY, unit }: { translateY: number; unit: string }) => ({
    style: {
      transform: `translateY(${translateY}${unit}) translateZ(0)`,
    },
  })
)`
  height: 100%;
  width: 100%;
  will-change: transform;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Parallax = ({
  speed = PARALLAX_DEFAULT_SPEED,
  y,
  children,
  unit = 'px',
  disabled,
  ...props
}: PositionProps &
  WidthProps &
  HeightProps & {
    speed?: number;
    y?: [number | null | undefined, number | null | undefined];
    unit?: 'px' | 'vh' | 'vw' | '%';
    // children?: ({}) => ?React.Node,
    children?: ReactNode;
    disabled?: boolean;
  }) => {
  const [, scrollY] = useContext(ScrollContext);
  const viewportSize = useContext(ViewportContext);
  const [translateY, setTranslateY] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    window.requestAnimationFrame(() => {
      if (ref && ref.current) {
        const height = ref.current.offsetHeight;
        const offsetY = ref.current.getBoundingClientRect().top;
        const inView = offsetY > 0 - height && offsetY < window.innerHeight;
        const maxHeight = window.innerHeight + 2 * height;

        if (inView) {
          const tY = speed * (1 - (offsetY + height) / maxHeight);

          if (translateY !== tY) {
            setTranslateY(tY);
          }
        }
      }
    });
  }, [scrollY, speed, ref, viewportSize, translateY]);
  return disabled ? (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...props}>{children}</Box>
  ) : (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Container ref={ref} {...props}>
      {/* @ts-expect-error Fix types */}
      <TransformContainer translateY={translateY} unit={unit}>
        {translateY && children}
      </TransformContainer>
    </Container>
  );
};

export default Parallax;
